import { Link } from "react-router-dom";
import { blogCategoryPath } from "@/lib/blog";

/**
 * Kategori rozeti — blog_categories.color alanından dinamik renk alır.
 * `as="link"` (default) verilirse <Link>, `as="span"` verilirse statik.
 * `active=true` ise dolu, değilse outline görünüm.
 */
export function CategoryChip({
  name,
  slug,
  color = "#22A7D1",
  lang = "tr",
  active = false,
  as = "link",
  size = "md",
  className = "",
}) {
  const sizeClass = size === "sm" ? "text-xs px-2.5 py-1" : "text-xs px-3 py-1.5";

  const filledStyle = {
    backgroundColor: color,
    color: "white",
    borderColor: color,
  };
  const outlineStyle = {
    color: color,
    borderColor: hexWithAlpha(color, 0.3),
    backgroundColor: hexWithAlpha(color, 0.08),
  };

  const baseClass =
    "inline-flex items-center gap-1.5 font-bold rounded-full border transition-all hover:-translate-y-0.5";

  const style = active ? filledStyle : outlineStyle;

  if (as === "span" || !slug) {
    return (
      <span className={`${baseClass} ${sizeClass} ${className}`} style={style}>
        {name}
      </span>
    );
  }

  return (
    <Link
      to={blogCategoryPath(lang, slug)}
      className={`${baseClass} ${sizeClass} ${className}`}
      style={style}
    >
      {name}
    </Link>
  );
}

function hexWithAlpha(hex, alpha) {
  if (!hex || !hex.startsWith("#") || hex.length < 7) return hex;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
